'use client'

import { cn } from '@/shared/lib/classnames'
import { RadioGroup, RadioGroupItem, RadioGroupItemProps, RadioGroupProps } from './radio-group'
import { useId } from 'react'

export interface ComponentProps {
  options: Record<string, any>[]
  valueFieldName?: string
  labelFieldName?: string
  idFieldName?: string
  radioGroupProps?: RadioGroupProps
  radioGroupItemProps?: RadioGroupItemProps
  className?: string
  slots?: {
    errorMessage?: React.ReactNode
  }
  onOptionClick?: (v: Record<string, any>) => void
}

export default function Component({
  options,
  valueFieldName = 'value',
  labelFieldName = 'label',
  slots,
  radioGroupProps,
  radioGroupItemProps,
  className,
  onOptionClick,
}: ComponentProps) {
  const ID = useId()

  return (
    <RadioGroup
      {...radioGroupProps}
      onValueChange={(v) => {
        radioGroupProps?.onValueChange && radioGroupProps?.onValueChange(String(v))
        onOptionClick && onOptionClick(options.find((item) => item?.[valueFieldName] == v) || {})
      }}
      className={cn('flex flex-col space-y-1', radioGroupProps?.className)}
    >
      {options.map((item, index) => {
        const label = item?.[labelFieldName]
        const value = item?.[valueFieldName]
        if (value == null) return null
        return (
          <label
            id={String(ID)}
            key={index}
            className={cn('flex items-center space-x-2 cursor-pointer text-wrap', className)}
          >
            <RadioGroupItem {...radioGroupItemProps} value={String(value)} id={String(ID)} />
            <div className="max-w-[90%]">{label}</div>
          </label>
        )
      })}

      {slots?.errorMessage && slots?.errorMessage}
    </RadioGroup>
  )
}
